import PayPal1 from './PayPal1'
export default PayPal1
